import Spinner from './Spinner';
const Button = ({ children, loading, disabled, variant = 'primary', className = '', ...props }) => {
  const v = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    danger: 'btn-danger',
    ghost: 'btn-ghost',
  };
  return (
    <button {...props} disabled={loading || disabled}
      className={`flex items-center justify-center gap-2 ${v[variant] || v.primary} ${className}`}>
      {loading && <Spinner />}{children}
    </button>
  );
};
export default Button;
